import { Check, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { WHATSAPP_LINK, waLink } from "@/lib/site";

const plans = [
    {
        name: "Agente WhatsApp",
        price: "1.097",
        desc: "Atendimento e agendamento automáticos no WhatsApp do seu negócio.",
        message:
            "Olá Tales, vi o site e tenho interesse no Agente WhatsApp. Quando podemos conversar?",
        features: [
            "Nunca mais perde cliente por demora na resposta",
            "Entende até áudio — o cliente fala do jeito que quiser",
            "Agenda sozinho, direto na sua agenda",
            "Reduz falta com lembrete automático (24h, 1h antes ou como preferir)",
            "Resolve remarcação sem ocupar sua secretária",
        ],
        highlight: false,
    },
    {
        name: "Completo",
        price: "2.197",
        desc: "WhatsApp + Voz trabalhando juntos. Nenhum cliente escapa.",
        message:
            "Olá Tales, vi o site e tenho interesse no Agente Completo. Quando podemos conversar?",
        features: [
            "Tudo do Agente WhatsApp",
            "Tudo do Agente de Ligação",
            "Atende em qualquer canal, sem intervalo, 24/7",
            "Prioridade no seu acompanhamento",
        ],
        highlight: true,
        tag: "Mais completo",
    },
    {
        name: "Agente de Ligação",
        price: "1.497",
        desc: "Atendimento por ligação telefônica com voz natural em PT-BR.",
        message:
            "Olá Tales, vi o site e tenho interesse no Agente de Ligação. Quando podemos conversar?",
        features: [
            "Atende ligações 24h, todos os dias",
            "Coleta os dados do cliente e já agenda",
            "Manda o resumo da ligação pro seu WhatsApp",
            "Resolve remarcação e cancelamento sem você",
        ],
        highlight: false,
    },
];

export const Pricing = () => {
    return (
        <section id="precos" className="relative py-24 md:py-32 lg:py-40">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 h-[400px] w-[700px] dg-glow opacity-50" />
            <div className="relative max-w-6xl mx-auto px-6 md:px-12">
                <Reveal>
                    <p className="text-sm md:text-base font-semibold uppercase tracking-widest text-[#94B4FF]">
                        Investimento
                    </p>
                    <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#F5F5F5]">
                        Investimento
                    </h2>
                    <p className="mt-5 text-base lg:text-lg text-[#F5F5F5]/70 max-w-2xl">
                        A implementação personalizada é um valor único, combinado com
                        você na primeira conversa. Sem contrato de longo prazo, sem
                        surpresas.
                    </p>
                    <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-[#3B6FFF]/30 bg-[#3B6FFF]/10 px-4 py-2 text-sm font-medium text-[#94B4FF]">
                        Custa menos que um novo funcionário — e atende 24h por dia,
                        todos os dias.
                    </p>
                </Reveal>

                <div className="mt-14 grid md:grid-cols-3 gap-6 md:gap-8 items-stretch">
                    {plans.map((p, i) => (
                        <Reveal key={p.name} delay={i * 0.1}>
                            <div
                                data-testid={`pricing-card-${i}`}
                                className={`relative flex flex-col h-full rounded-3xl p-8 ${
                                    p.highlight
                                        ? "border border-[#3B6FFF] bg-gradient-to-b from-[#141B33] to-[#121218] shadow-[0_0_55px_rgba(59,111,255,0.28)] md:-translate-y-3"
                                        : "border border-[#1E1E28] bg-[#121218]"
                                }`}
                            >
                                {p.highlight && (
                                    <div className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-[#3B6FFF] px-4 py-1 text-xs font-semibold text-white">
                                        {p.tag}
                                    </div>
                                )}
                                <h3 className="font-display text-lg font-semibold text-[#F5F5F5]">
                                    {p.name}
                                </h3>
                                <p className="mt-2 text-sm text-[#F5F5F5]/55 min-h-[40px]">
                                    {p.desc}
                                </p>
                                <div className="mt-6 flex items-baseline gap-1">
                                    <span className="text-sm text-[#7A7A90]">
                                        A partir de R$
                                    </span>
                                    <span className="font-display text-4xl font-extrabold text-[#F5F5F5]">
                                        {p.price}
                                    </span>
                                    <span className="text-sm text-[#7A7A90]">/mês</span>
                                </div>
                                <ul className="mt-6 space-y-3 flex-1">
                                    {p.features.map((f) => (
                                        <li
                                            key={f}
                                            className="flex items-start gap-3 text-sm text-[#F5F5F5]/80"
                                        >
                                            <Check className="mt-0.5 w-4 h-4 flex-shrink-0 text-[#3B6FFF]" />
                                            <span>{f}</span>
                                        </li>
                                    ))}
                                </ul>
                                <a
                                    data-testid={`pricing-cta-${i}`}
                                    href={waLink(p.message)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`mt-8 inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 font-semibold transition-all ${
                                        p.highlight
                                            ? "bg-[#3B6FFF] text-white hover:bg-[#2d5be0] shadow-[0_0_25px_rgba(59,111,255,0.4)]"
                                            : "border border-[#1E1E28] bg-[#0A0A0F] text-[#F5F5F5] hover:border-[#3B6FFF]/50"
                                    }`}
                                >
                                    Quero começar
                                    <ArrowRight className="w-4 h-4" />
                                </a>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.2}>
                    <p className="mt-12 text-center text-[#F5F5F5]/60 max-w-3xl mx-auto leading-relaxed">
                        A taxa de implementação cobre o desenvolvimento e a configuração
                        sob medida do seu agente. Projeto entregue em até 10 dias.
                    </p>
                    <div className="mt-8 flex justify-center">
                        <a
                            data-testid="pricing-main-cta"
                            href={WHATSAPP_LINK}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#3B6FFF] px-8 py-4 font-semibold text-white shadow-[0_0_30px_rgba(59,111,255,0.4)] hover:bg-[#2d5be0] transition-all"
                        >
                            Experimentar agora
                            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                        </a>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};

export default Pricing;
